module.exports = __webpack_public_path__ + "static/media/helps.5217fa96.png";